import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import InspectionHub from '../components/InspectionHub';
import InspectionHubLevage from '../components/InspectionHubLevage';
import InspectionHubThermographie from '../components/InspectionHubThermographie';
import { useMissionContext } from '../context/MissionContext';

/**
 * @param {{ kind: 'electricite' | 'levage' | 'thermo' }} props
 */
export default function InspectionPage({ kind }) {
  const { missionId } = useParams();
  const { missions, isLoading } = useMissionContext();
  const navigate = useNavigate();

  const mission = missions.find((m) => String(m.id) === String(missionId));

  const onBack = () => {
    navigate(`/mission/${encodeURIComponent(missionId)}`);
  };

  const onGoHome = () => {
    navigate('/');
  };

  const handleStepClick = (step) => {
    alert('Formulaire "' + step.label + '" en cours\n\nEtape: ' + step.key);
  };

  if (isLoading && !mission) {
    return (
      <div className="app">
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            flexDirection: 'column',
            gap: '20px',
          }}
        >
          <div className="spinner-large"></div>
          <p>Chargement...</p>
        </div>
      </div>
    );
  }

  if (!mission) {
    return (
      <div className="app" style={{ padding: '24px', textAlign: 'center' }}>
        <p style={{ marginBottom: '16px', color: '#334155' }}>Mission introuvable.</p>
        <button type="button" className="sync-button" onClick={() => navigate('/missions')}>
          Retour aux missions
        </button>
      </div>
    );
  }

  if (kind === 'levage') {
    return (
      <div className="app">
        <InspectionHubLevage mission={mission} onBack={onBack} onGoHome={onGoHome} />
      </div>
    );
  }

  if (kind === 'thermo') {
    return (
      <div className="app">
        <InspectionHubThermographie mission={mission} onBack={onBack} onGoHome={onGoHome} />
      </div>
    );
  }

  return (
    <div className="app">
      <InspectionHub mission={mission} onBack={onBack} onStepClick={handleStepClick} onGoHome={onGoHome} />
    </div>
  );
}
